import { useEffect } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Login from "./Login/Login";
import {
  homePath,
  isReservedAppSegment,
  legacyAppPathToPrefixed,
  normalizeAlias,
} from "../utils/contractPath";

/**
 * Decide o destino do gate de login por alias.
 * Pure — coberta por testes unitários (isolamento multi-contrato).
 *
 * @returns {"wait"|"legacy"|"logout_and_login"|"home"|"login"}
 */
export function resolveAliasLoginGateAction({
  authReady,
  isAuthenticated,
  cdAlias,
  sessionAlias,
}) {
  const alias = normalizeAlias(cdAlias);
  const session = normalizeAlias(sessionAlias);

  if (!authReady && !isAuthenticated) return "wait";
  if (isReservedAppSegment(cdAlias)) return "legacy";

  const mismatch = Boolean(
    isAuthenticated && session && alias && session !== alias
  );
  if (mismatch) return "logout_and_login";

  if (isAuthenticated && session && alias && session === alias) return "home";
  return "login";
}

/** Login em /:cdAlias; se o segmento for rota de app legada, prefixa o alias. */
export function AliasLoginGate() {
  const { cdAlias } = useParams();
  const location = useLocation();
  const { isAuthenticated, authReady, user, logout } = useAuth();
  const alias = normalizeAlias(cdAlias);
  const sessionAlias = normalizeAlias(user?.cd_alias);
  const action = resolveAliasLoginGateAction({
    authReady,
    isAuthenticated,
    cdAlias,
    sessionAlias,
  });

  useEffect(() => {
    if (action !== "logout_and_login") return undefined;
    logout();
    return undefined;
  }, [action, logout]);

  if (action === "wait" || action === "logout_and_login") return null;

  if (action === "legacy") {
    const target = legacyAppPathToPrefixed(
      location.pathname,
      location.search,
      location.hash,
      user?.cd_alias
    );
    if (target) return <Navigate to={target} replace />;
    return <Navigate to="/" replace />;
  }

  if (action === "home") {
    return <Navigate to={homePath(alias)} replace />;
  }

  return <Login />;
}
